import React, { Component } from 'react'
import InvoiceModal from './InvoiceModal'
import { get, isEmpty, pick } from 'lodash'
import { message, Select } from 'antd'
import Invoices from '../../../../../../api/Sales/Invoices'
import { normalizeDateTimeToDate, numVal, strVal } from '../../../../../../modules/Utils'
import moment from 'moment'
import { compose } from 'recompose'
import withUrlFetch from '../../../../../../elements/Select/withUrlFetch'
import withSpinning from '../../../../../../elements/HOC/withSpinning'
import withSort from '../../../../../../elements/HOC/withSort'
import CustomSelect from '../../../../../../elements/Select/CustomSelect'

class InvoiceModalCont extends Component {
  calculateSum = (line, invoiced) => {
    let nt = Math.round(invoiced * line.rate * 100) / 100
    let tx = Math.round(invoiced * numVal(line, 'tax.rate') * 100) / 100
    const gross = Math.round((tx + nt) * 100) / 100
    const amount = { net: nt, tax: tx, gross }
    return { ...line, invoiced, amount }
  }
  state = {
    billLines: [...this.props.billLines]
      .map((b) => {
        b.unit -= numVal(b, 'invoiced') < 0 ? 0 : numVal(b, 'invoiced')
        const invoiced = b.unit
        return { ...this.calculateSum(b, invoiced), percentage: 100 }
      })
      .filter((b) => b.unit > 0),
    order: this.props.order || {},
    keyAttr: '_key',
    invoice: {},
    selection: [],
    ContractsSelectCmp: Select,
  }
  api = new Invoices()
  invoiceFormRef = React.createRef()
  invoiceBooking = async () => {
    const values = await this.checkForm()
    let { billLines } = this.state
    billLines = billLines
      .filter((b) => b.unit > 0)
      .map((b) => {
        b.unit = b.invoiced
        b.invoicing = {
          date: normalizeDateTimeToDate({ value: moment() }, 'value', true),
        }
        return pick(b, ['invoicing', '_key', '_id', '_rev'])
      })
    if (billLines.length < 1) {
      message.error('No Bookings Found')
      return
    }
    try {
      this.setState({
        invoicing: true,
      })
      let data = await this.api.usage({
        date: normalizeDateTimeToDate({ value: moment() }, 'value', true),
        lines: billLines,
        _id: strVal(values, 'contract._id'),
      })
      this.setState({
        invoicing: false,
      })
      message.success(
        <span>
          Invoice has been created. Click{' '}
          <a href={`#/clients/invoices/${data.invoiceDB._key}/view`} target={'_blank'}>
            {' '}
            here
          </a>{' '}
          to view{' '}
        </span>
      )
      this.props.onCancelInvoice()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ invoicing: false })
    }
  }

  cancel = (_key) => {
    const { billLines } = this.state
    const newData = [...billLines]
    const target = newData.find((item) => _key === item[this.state.keyAttr])
    if (target) {
      delete target.editable
      if (Object.keys(target).length === 1 && Object.keys(target)[0] === [this.state.keyAttr])
        this.remove(target[this.state.keyAttr])
      else
        this.setState({
          billLines: newData,
        })
    }
  }
  remove = (_key) => {
    const { billLines } = this.state
    let newData = [...billLines]
    newData = newData.filter((item) => _key !== item[this.state.keyAttr])
    this.setState({
      billLines: newData,
    })
  }
  edit = (_key) => {
    const { billLines } = this.state
    let newData = [...billLines]
    const target = newData.find((item) => _key === item[this.state.keyAttr])
    if (target) {
      target.editable = true
      this.setState({
        billLines: newData,
      })
    }
  }
  save = (_key) => {
    const { billLines } = this.state
    let newData = [...billLines]
    let target = newData.find((item) => _key === item[this.state.keyAttr])
    if (target) {
      delete target.editable
      delete target.percentage
      this.setState({
        billLines: newData,
      })
    }
  }
  handleChange = (value, _key, column) => {
    const { billLines } = this.state
    let newData = [...billLines]
    let target = newData.find((item) => _key === item[this.state.keyAttr])
    if (target) {
      target[column] = value
      let { amount } = this.calculateSum(target, target.invoiced)
      target['amount'] = amount
      this.setState({
        billLines: newData,
      })
    }
  }
  checkForm = () => {
    return new Promise((res, rej) => {
      this.invoiceFormRef.current.validateFields((err, values) => {
        if (!err) {
          res(values)
        }
      })
    })
  }
  onChangeCompany = (company) => {
    const url = `products/categories` + `?owner=${company}` + '&select=*'
    this.url = url
    const CategorySelect = compose(
      withUrlFetch({
        name: 'products_categories',
        url: url,
        cache: true,
        forceFetch: true,
      }),
      withSpinning,
      withSort
    )(CustomSelect)
    this.invoiceFormRef.current && this.invoiceFormRef.current.resetFields(['client._id', 'contract._id'])
    this.setState({ company, CategorySelect })
  }
  onChangeClient = (client) => {
    this.invoiceFormRef.current && this.invoiceFormRef.current.resetFields(['contract._id'])
    if (!isEmpty(client)) {
      const owner = client.replace('partners/', '')
      const { company } = this.state
      const url = `clients/` + (isEmpty(owner) ? '' : `${owner}`) + `/contracts?company=${company}&state=active`
      const ContractsSelectCmp = compose(
        withUrlFetch({
          name: 'clients_contracts',
          url: url,
          cache: true,
          forceFetch: true,
        }),
        withSpinning,
        withSort
      )(CustomSelect)
      this.setState({ client, ContractsSelectCmp })
    } else {
      this.setState({
        client: '',
        ContractsSelectCmp: Select,
        url: '',
      })
    }
  }
  onChangeContract = (contract) => {
    if (!isEmpty(contract)) {
      this.setState({
        contract,
      })
    }
  }
  tableRef = React.createRef()
  toggleSelection = (key) => {
    let selection = [...this.state.selection]
    const keyIndex = selection.indexOf(key)
    if (keyIndex >= 0) {
      selection = [...selection.slice(0, keyIndex), ...selection.slice(keyIndex + 1)]
    } else {
      selection.push(key)
    }
    this.setState({ selection })
  }
  toggleAll = () => {
    const selectAll = !this.state.selectAll
    const selection = []
    if (selectAll) {
      const wrappedInstance = this.tableRef.current
      const currentRecords = wrappedInstance.getResolvedState().sortedData
      currentRecords.forEach((item) => {
        selection.push(item._original._id)
      })
    }
    this.setState({ selectAll, selection })
  }
  isSelected = (key) => {
    return this.state.selection.includes(key)
  }
  removeSelectedLines = () => {
    // const filtered = this.state.billLines.filter(
    //   function(e) {
    //     return this.indexOf(e) < 0;
    //   },
    //   [2, 4]
    // );
    this.setState((prvState) => ({
      billLines: prvState.billLines.filter((f) => !prvState.selection.find((ff) => ff === f._id)),
    }))
  }

  render() {
    return (
      <InvoiceModal
        {...this.props}
        {...this.state}
        {...pick(this, [
          'invoiceBooking',
          'cancel',
          'remove',
          'edit',
          'save',
          'handleChange',
          'invoiceFormRef',
          'onChangeCompany',
          'onChangeContract',
          'onChangeClient',
          'tableRef',
          'toggleSelection',
          'toggleAll',
          'isSelected',
          'removeSelectedLines',
        ])}
      />
    )
  }
}

InvoiceModalCont.propTypes = {}
InvoiceModalCont.defaultProps = { billLines: [] }

export default InvoiceModalCont
